'use client';

import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import React from 'react';
import pkg from '../../package.json';

Bugsnag.start({
  apiKey: process.env.NEXT_PUBLIC_BUGSNAG_API_KEY!,
  appVersion: pkg.version,
  plugins: [new BugsnagPluginReact()],
  releaseStage:
    process.env.NEXT_PUBLIC_STAGE! === 'prod' ? 'production' : 'development',
});

export function setBugsnagUser(id: string) {
  Bugsnag.setUser(id);
}

export function notifyBugsnag(error: Error) {
  Bugsnag.notify(error);
}
export const BugSnagErrorBoundary =
  Bugsnag.getPlugin('react')!.createErrorBoundary(React);
